/**
 * applyButtonGroupStyles
 *
 * Post-render DOM utility: reads data attributes from .cta-group containers
 * and their .cta-btn children, then applies the corresponding inline styles.
 *
 * Properties handled:
 *   data-gap on .cta-group       → group.style.gap
 *   data-btn-width on a.cta-btn  → btn.style.width
 *                                   (mobile SCSS override: width: 100% !important
 *                                    at max-width: 576px safely overrides this)
 *
 * Properties NOT handled here (already CSS-driven, no change needed):
 *   data-btn-align  → tinyeditor-custom.scss attribute selectors
 *   CSS classes     → tinyeditor-custom.scss class rules (color, size)
 *
 * Idempotent: setting a style property to the same value is a browser no-op.
 */
export function applyButtonGroupStyles(container: HTMLElement): void {
    const groups = container.querySelectorAll<HTMLElement>(
        '[data-component-type="cta-group"]'
    );
    if (groups.length === 0) return;

    groups.forEach((group) => {
        // Apply gap from data-gap attribute
        const gap = group.dataset.gap;
        if (gap && gap.trim() !== '') {
            group.style.gap = gap.trim();
        }

        // Apply width from data-btn-width on each child button
        const buttons = group.querySelectorAll<HTMLElement>('a.cta-btn');
        buttons.forEach((btn) => {
            const btnWidth = btn.dataset.btnWidth; // data-btn-width → dataset.btnWidth
            if (btnWidth && btnWidth.trim() !== '') {
                btn.style.width = btnWidth.trim();
            }
        });
    });
}
